<script setup lang="ts">

import { useRoute } from "vue-router";

const route = useRoute()

const tabs = [
  {
    name: 'Data Fields',
    route: 'nir-master-data-fields',
    icon: 'fa-solid fa-users'
  },
  {
    name: 'Field Lookups',
    route: 'nir-master-data-lookups',
    icon: 'fa-solid fa-user-group'
  },
  {
    name: 'Entity Types',
    route: 'nir-master-data-types',
    icon: 'fa-solid fa-user-tag'
  },
  {
    name: 'Services',
    route: 'nir-master-data-services',
    icon: 'fa-solid fa-briefcase'
  },
  {
    name: 'Contacts Configuration',
    route: 'nir-master-data-contacts',
    icon: 'fa-solid fa-phone'
  },
  {
    name: 'Regulation Forms Templates',
    route: 'nir-master-data-regulation-forms',
    icon: 'fa-solid fa-file-lines'
  },
  {
    name: 'Registration Status Configuration',
    route: 'nir-master-data-registration-statuses',
    icon: 'fa-solid fa-circle-check'
  },
  {
    name: "eRegistry Mapping",
    route: 'nir-master-data-obrs-form-update',
    icon: 'fa-solid fa-pen-to-square'
  },

]

const isActiveTab = (tabRoute: string) => {
  return route.name === tabRoute
}

</script>

<template>
  <div class="flex-1 flex flex-col overflow-hidden">
    <!-- Tabs -->
    <div class="bg-white">
      <div class="border-b border-gray-200">
        <nav class="flex flex-wrap gap-x-6 gap-y-0 px-4" aria-label="Tabs">
          <router-link
            v-for="tab in tabs"
            :key="tab.route"
            :to="{ name: tab.route }"
            :class="[
              isActiveTab(tab.route)
                ? 'border-primary text-primary'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
              'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition'
            ]">
            <i :class="tab.icon + ' text-sm'"></i>
            <span>{{ tab.name }}</span>
          </router-link>
        </nav>
      </div>

      <!-- Tab Content -->
      <div class="flex flex-col p-2">
        <RouterView />
      </div>
    </div>
  </div>
</template>

<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0;
}
</style>
